import React from "react";
import { relativeTime } from "./deliveryHealthHelpers";

function ScopeLabel({ ids }) {
  if (!ids?.length) return null;
  const all = ids[0] === "*";
  return (
    <div className="text-[10px] text-zinc-500">
      {all ? "All destinations" : `${ids.length} picked`}
    </div>
  );
}

function NotifyCell({ alert }) {
  return (
    <td className="py-2 px-4 text-[11px]">
      {alert.notify_email && <div>{alert.notify_email}</div>}
      {alert.notify_slack_webhook && <div className="text-zinc-500">slack</div>}
    </td>
  );
}

function ActivePill({ isActive }) {
  const cls = isActive ? "bg-black text-white" : "text-zinc-500 border-zinc-300";
  return (
    <span className={`px-2 py-0.5 text-[10px] border ${cls}`}>
      {isActive ? "on" : "off"}
    </span>
  );
}

function RowActions({ id, onEvaluate, onDelete }) {
  return (
    <td className="py-2 px-4">
      <button onClick={() => onEvaluate(id)} data-testid={`alert-eval-${id}`}
        className="border border-black px-2 py-1 text-[10px] uppercase tracking-widest hover:bg-black hover:text-white mr-1">
        Test
      </button>
      <button onClick={() => onDelete(id)} data-testid={`alert-delete-${id}`}
        className="border border-red-600 text-red-700 px-2 py-1 text-[10px] uppercase tracking-widest hover:bg-red-600 hover:text-white">
        Delete
      </button>
    </td>
  );
}

/** List view of all configured alert rules. */
export default function AlertRulesTable({ alerts, onEvaluate, onDelete }) {
  return (
    <div className="brut-card overflow-x-auto">
      <table className="w-full text-xs font-mono">
        <thead>
          <tr className="border-b border-black text-[10px] uppercase tracking-widest">
            <th className="py-2 px-4 text-left">Name</th>
            <th className="py-2 px-4 text-left">Threshold</th>
            <th className="py-2 px-4 text-left">Window</th>
            <th className="py-2 px-4 text-left">Notify</th>
            <th className="py-2 px-4 text-left">Last fired</th>
            <th className="py-2 px-4 text-left">Active</th>
            <th className="py-2 px-4 text-left"></th>
          </tr>
        </thead>
        <tbody>
          {alerts.map((a) => (
            <tr key={a.id} className="border-b border-zinc-200" data-testid={`alert-row-${a.id}`}>
              <td className="py-2 px-4">
                <div className="font-semibold">{a.name}</div>
                <ScopeLabel ids={a.destination_ids} />
              </td>
              <td className="py-2 px-4">&lt; {a.threshold_pct}%</td>
              <td className="py-2 px-4">{a.window_minutes}m</td>
              <NotifyCell alert={a} />
              <td className="py-2 px-4 text-[11px]">
                {a.last_fired_at ? relativeTime(a.last_fired_at) : "—"}
              </td>
              <td className="py-2 px-4"><ActivePill isActive={a.is_active} /></td>
              <RowActions id={a.id} onEvaluate={onEvaluate} onDelete={onDelete} />
            </tr>
          ))}
          {!alerts.length && (
            <tr><td colSpan={7} className="py-6 text-center label-mono">No alert rules configured</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
